import { useEffect, useState } from "react";
import API from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Flask } from "@phosphor-icons/react";

/** Pick substances from the COSHH register to drop into a RAMS COSHH table — product, hazards and controls pre-filled. */
export default function CoshhRegisterPicker({ open, onOpenChange, onPick }) {
  const [subs, setSubs] = useState([]);
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(new Set());
  useEffect(() => { if (open) API.get("/coshh/substances", { params: { slim: 1 } }).then(({ data }) => setSubs(data.substances || [])).catch(() => setSubs([])); }, [open]);
  const rows = subs.filter(s => !q || `${s.product} ${s.manufacturer} ${s.reference}`.toLowerCase().includes(q.toLowerCase()));
  const toggle = (id) => setSel(s => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const confirm = () => { onPick(subs.filter(s => sel.has(s.id))); setSel(new Set()); onOpenChange(false); };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="coshh-register-picker">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Flask size={18} /> Add from the COSHH register</DialogTitle><DialogDescription>Tick the substances this task uses. Hazards and controls come from their issued assessments.</DialogDescription></DialogHeader>
        <Input value={q} onChange={e => setQ(e.target.value)} placeholder="Search products…" className="h-8 text-sm" data-testid="coshh-picker-search" />
        <div className="max-h-72 overflow-y-auto divide-y divide-border rounded-md border border-border">
          {rows.map(s => (
            <label key={s.id} className="flex items-start gap-2 p-2 text-sm cursor-pointer hover:bg-muted/40" data-testid={`coshh-picker-row-${s.id}`}>
              <input type="checkbox" className="mt-1" checked={sel.has(s.id)} onChange={() => toggle(s.id)} />
              <span className="min-w-0"><span className="font-medium">{s.product}</span><span className="text-muted-foreground text-xs"> · {s.reference}{s.manufacturer ? ` · ${s.manufacturer}` : ""}</span>
                <span className="block text-[11px] text-muted-foreground truncate">{s.hazard_line}{!s.assessment_ready && " · assessment not issued yet"}</span></span>
            </label>
          ))}
          {!rows.length && <p className="p-4 text-xs text-muted-foreground text-center">{subs.length ? "No matches." : "The COSHH register is empty — add substances under Health & Safety → COSHH."}</p>}
        </div>
        <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button><Button onClick={confirm} disabled={!sel.size} data-testid="coshh-picker-confirm">Add {sel.size || ""}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
